// OpenTelemetry instrumentation - only initialize if enabled
// Set REACT_APP_ENABLE_OTEL=true to enable, or leave unset/false to disable
if (process.env.REACT_APP_ENABLE_OTEL === 'true') {
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { WebTracerProvider, BatchSpanProcessor } = require('@opentelemetry/sdk-trace-web');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { DocumentLoadInstrumentation } = require('@opentelemetry/instrumentation-document-load');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { ZoneContextManager } = require('@opentelemetry/context-zone');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { registerInstrumentations } = require('@opentelemetry/instrumentation');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { OTLPTraceExporter } = require('@opentelemetry/exporter-trace-otlp-http');

    // Configure the exporter
    const exporter = new OTLPTraceExporter({
      url: process.env.REACT_APP_OTEL_COLLECTOR_URL || 'http://localhost:4318/v1/traces', // Ensure this endpoint is accessible from the browser
    });

    const provider = new WebTracerProvider({
      spanProcessors: [new BatchSpanProcessor(exporter)],
    });

    provider.register({
      contextManager: new ZoneContextManager(),
    });

    registerInstrumentations({
      instrumentations: [
        new DocumentLoadInstrumentation(),
      ],
    });

    console.log('OpenTelemetry initialized');
  } catch (error) {
    // Fail gracefully if OTEL setup fails - don't prevent app from loading
    console.warn('Failed to initialize OpenTelemetry instrumentation:', error.message);
  }
} else {
  // Silently skip initialization if OTEL is not enabled
  if (process.env.NODE_ENV === 'development') {
    console.log('OpenTelemetry instrumentation disabled (set REACT_APP_ENABLE_OTEL=true to enable)');
  }
}
